import RulesDrawer from './RulesDrawer';

export default RulesDrawer;
